import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { LicensePage } from './license';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LicensePage
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild([{ path: '', component: LicensePage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ]
})
export class LicensePageModule {}
